import {ReportColumns} from './report-columns';

export class ReportInfoColumns extends ReportColumns implements ReportColumns {
    constructor(infoColumns: any, skipIdInit = false) {
        super(infoColumns, skipIdInit);
    }

    isLocked = () => this.columnType === 'Mandatory';
}
